
import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import _ from 'lodash';
import { SharedModule } from '../../../../shared/shared.module';
import { VendorService } from '../../../../services/vendor.service';
import { vendor, vendorGridResponse } from '../../../../model/masters.model';
import { gridPageRequest, gridPagination } from '../../../../model/common/common.model';
import { ConfirmationService, MessageService } from 'primeng/api';
import { LoaderComponent } from '../../../loader/loader.component';
import { Table } from 'primeng/table';
@Component({
  selector: 'app-vendor-list',
  standalone: true,
  imports: [SharedModule, CommonModule, LoaderComponent],
  templateUrl: './vendor-list.component.html',
  styleUrl: './vendor-list.component.scss'
})
export class VendorListComponent implements OnInit {
  @ViewChild('dt1') dt1: Table | undefined;

  selectedVendor: any[] = [];
  searchKey: any;
  paginator: boolean | undefined;

  constructor(private route: Router, private Vendorservice: VendorService, private confirmationService: ConfirmationService, private messageService: MessageService) { }
  vendors: vendor[] = [];
  start: number = 0;
  rowsPerPage: number = 5;

  gridPagination: gridPagination = {
    first: 0,
    last: 0,
    totalRecords: 0
  }

  result: vendorGridResponse = {
    vendors: [],
    totalRecords: 0
  }

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 20,
    id: 0
  }

  loader: boolean = false;

  ngOnInit(): void {
    this.getVendor();
    document.title = 'Vendor List';
    this.searchEffect();
  }


  getVendor(): void {
    this.Vendorservice.getAllVendor(this.pageRequest).subscribe({
      next: (data: any) => {
        if (data && data.vendors) {
          //this.vendors = data.vendors;
          this.result = {
            ...data,
            vendors: data.vendors
            // vendors: data.vendors.map((vendor: any) => ({
            //   ...vendor,
            //   // vendorImage: vendor.vendorImage
            //   //   ? `data:image/jpeg;base64,${vendor.vendorImage}`
            //   //   : './assets/no-image.jpg'
            // }))
          };
        } else {
          this.vendors = [];
        }
      },
      error: error => {
        console.error(error);
      }
    });
  }

  CreateVendor() {
    this.route.navigate(['/home/createvendors']);
  }

  editVendor(data?: any) {
    if (data) {
      this.route.navigate(['/home/createvendors'], { queryParams: { 'vendorId': data }, skipLocationChange: true },);
    } else {
      this.route.navigate(['/home/createvendors'], { queryParams: { 'vendorId': this.selectedVendor[0].vendorId }, skipLocationChange: true },);
    }
  }

  deleteVendor() {
    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {
        this.loader = true;

        var vendorId = _.map(this.selectedVendor, 'vendorId');

        this.Vendorservice.deleteVendor(vendorId).subscribe({
          next: (data: any) => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Vendor deleted successfully.' });
            this.loader = false;
            this.selectedVendor = [];
            this.getVendor();
          },
          error: error => {
            this.loader = false;
            console.log(error);
          }
        })
      },
      reject: () => {
      }
    });
  }

  loadvendors(event: any): void {
    if (this.searchKey) return;

    this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
    this.getVendor();
  }



  searchVendor(): void {
    const filterValue = this.searchKey?.trim();
    if (!filterValue) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please enter a search keyword'
      });
      return;
    }

    this.Vendorservice.autoSearchVendor(filterValue).subscribe(
      (data: any) => {
        if (Array.isArray(data) && data.length > 0) {
          this.result.vendors = data.map((vendor: any) => ({
            ...vendor,
            vendorImage: vendor.vendorImage
              ? `data:image/jpeg;base64,${vendor.vendorImage}`
              : './assets/no-image.jpg'
          }));

          if (this.dt1) this.dt1.first = 0;

          this.gridPagination = {
            ...this.gridPagination,
            totalRecords: this.result.vendors.length
          };
        } else {
          this.result.vendors = [];
          this.messageService.add({
            severity: 'info',
            summary: 'No Results',
            detail: 'No vendors found for the given keyword.'
          });
        }
      },
      (error: any) => {
        console.log(error);
        this.result.vendors = [];
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to search vendors.'
        });
      }
    );
  }






  refreshData(): void {
    if (this.dt1) {
      this.dt1.first = 0;
      this.dt1.clear();
    }
    this.searchKey = '';
    this.pageRequest.pageIndex = 0;
    this.pageRequest.pageSize = 50;
    this.getVendor();
  }

  placeholder: string = 'Search By ';
  private messages: string[] = ['Vendor Code', 'Vendor Name', 'Mobile', 'Email', 'Address', 'City', 'State'];
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }

}
